import { AdmissionProcedure } from "../../models/private-billing/admission-procedure.model";
import { ProcedureStruct } from "./procedure.struct";

export class AdmissionProcedureStruct extends AdmissionProcedure {
    public idProcedure: number;
    public idTerminologyGroup: number;
    public terminologyGroupCode: string;
    public procedure: ProcedureStruct;
}